选择开户市场 @zhaoyr
自定义DICT_ITEM
更新UPDATE_COMPONENT_BUTTON_CLICK 传递点击事件并更新DICT_ITEM
<template>
  <el-form-item
    :label="title"
    :id="field.FIELD_ID"
    :ref="field.FIELD_ID"
    :class="itemClass"
    v-show="isShow"
    :prop="field.FIELD_ID"
    :rules="rules"
  >
    <div class="stock-list">
      <div
        class="stock-item"
        :class="{'stock-item-disable': item.isDisable, 'all-stock-disable': !item.stockEnable, 'allow-input-stkpbu': isAcceptInputStkpbu}"
        v-for="(item, index) in options"
        :key="index"
      >
        <div class="stock-block">
          <span  class="stock-label" >{{item.label}}</span>
          <el-checkbox
            v-model="item.stockEnable"
            :disabled="item.isDisable"
            @change="handleChecked($event, item)"
          >
          </el-checkbox>
        </div>
        <div class="stock-select">
          <div class="stock-select-inner">
            <el-radio-group v-model="item.SEL_TYPE">
              <el-radio
                v-if="isCanNewTrdAcct"
                class="stock-add-new"
                :class="item.newAddDisable ? 'stock-add-new-disable': ''"
                label="1"
                :key="index + item.value + '1'"
                :disabled="item.newAddDisable ? item.newAddDisable : !item.stockEnable"
                @click.native.prevent="handleClick($event, item, '1')"
                >新开</el-radio
              >
              <el-radio
                class="stock-use-exist"
                label="0"
                :key="index + item.value + '0'"
                :disabled="!item.stockEnable"
                @click.native.prevent="handleClick($event, item, '0')"
                >加挂</el-radio
              >
            </el-radio-group>
            <div v-show="item.SEL_TYPE == '0'">
              <el-select
                v-if="item.TRDACCT_LIST.length != 0"
                v-model="item.TRDACCT"
                class="self-selector stock-select-tracct"
                :disabled="item.SEL_TYPE != '0' || item.TRDACCT_LIST.length == 0"
                popper-class="stock-select-popper"
                :placeholder="
                  item.SEL_TYPE != '0' || item.TRDACCT_LIST.length == 0
                    ? '不可操作'
                    : '请选择证券账户'
                "
                @change="handleSelect(item,'0')"
              >
                <el-option
                  v-for="trdacct in item.TRDACCT_LIST"
                  :key="item.value +'-'+ trdacct.DICT_ITEM"
                  :value="trdacct.DICT_ITEM"
                  :label="trdacct.DICT_ITEM_NAME"
                  :disabled="trdacct.IS_DISABLE"
                >
                  <span v-html="trdacct.DICT_ITEM_html"></span>
                </el-option>
              </el-select>
              <el-input 
                v-else
                v-model="item.TRDACCT"
                class="self-input stock-input-tracct"
                :maxlength="10"
                :disabled="item.SEL_TYPE != '0' || item.isDisableAddStock"
                :placeholder="
                  item.SEL_TYPE != '0' || item.isDisableAddStock
                    ? '不可操作'
                    : '请输入证券账户'
                "
                @change="handleSelect(item,'0')"
              ></el-input>
            </div>
            <el-input 
              v-show="isAcceptInputStkpbu"
              v-model="item.STKPBU"
              class="self-input stock-input-stkpbu"
              :disabled="item.stkpbuDisabled || item.SEL_TYPE === ''" 
              :placeholder="
                item.SEL_TYPE === ''
                  ? '不可操作'
                  : '请输入交易单元'
              "
              @change="handleSelect(item,'1')"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <!-- 展开收起 -->
    <!-- <div class="stock-list-collapse" v-show="options.length > collapseNum">
      <span class="collapse-btn" @click="handleCollapse"
        >{{ collapseObj.text }}
        <i :class="'collapse-icon ' + collapseObj.iconClass"></i>
      </span>
    </div> -->
  </el-form-item>
</template>

<script>
import { isString } from "util";

export default {
  data () {
    return {
      itemClass: "open-biz-stock",
      checked: false,
      isDisabled: false,
      triggerType: "custom",//校验类型 custom是自定义的
      rules: [],
      options: "",
      optionsAll: "",
      collapseNum: 4,
      collapseStu: false, //展开收起状态
    };
  },
  props: ["field", "index", "groupId", "isBaseUI"],
  created () {
    this.rules.push({ validator: this.validatorField, trigger: this.triggerType });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;
    //控制展示所有板块
    this.collapseStu = this.field.showAllStock || false;
    this.initData();
    this.initDict();
  },
  computed: {
    isCanNewTrdAcct () {
      //证券账户新增-产品户不能新开，只能加挂
      if(["V0040"].indexOf(this.field.BUSI_CODE) !== -1){
        return this.$store.state.usertype !== "2";
      //是否允许新开
      } else if (!_.isEmpty(this.field.ALLOW_NEW_OPEN)){
        return this.field.ALLOW_NEW_OPEN === "1";
      }
      return true;
    },
    //非中登时间支持手动输入，否则禁止手动输入
    isAcceptInput () {
      let busiCode = this.field.BUSI_CODE;
      if (!this.field.IS_IN_CSDC && (this.$syscfg.isOrgOpenAcctBiz(busiCode) || this.$syscfg.isProOpenAcctBiz(busiCode))) {
        return true;
      }
      return false;
    },
    //支持手动输入交易单元
    isAcceptInputStkpbu () {
      if (!_.isEmpty(this.field.ALLOW_INPUT_STKPBU)){
        return this.field.ALLOW_INPUT_STKPBU === "1";
      }
      return false;
    },
    title: function () {
      return _.trim(this.field.FIELD_TITLE) ? this.field.FIELD_TITLE
        + (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":", "？"]).length ? "" : "：") : "";
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    dictChange: function () {
      return this.field.FIELD_DICT_NAME;
    },
    dictFilterChange: function () {
      return this.field.FIELD_DICT_FILTER;
    },
    dictDisable: function () {
      return this.field.FIELD_DICT_DISABLE;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    collapseObj: function () {
      if (this.collapseStu) {
        return {
          text: "收起",
          iconClass: "el-icon-arrow-up"
        };
      } else {
        return {
          text: "展开",
          iconClass: "el-icon-arrow-down"
        };
      }
    }
  },
  methods: {
    initData () { },
    initDict () {
      if (this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME != "") {
        this.optionsAll = [];
        this.options = [];
        let showArr;
        try {
          let filter = eval(this.field.FIELD_DICT_FILTER);
          if (filter.constructor == Array) {
            showArr = filter;
          } else {
            showArr = [];
          }
        } catch (exception) {
          showArr = [];
        }

        //展示但是不可编辑
        let disableArr = [];
        if (this.field.FIELD_DICT_DISABLE) {
          try {
            let disable = this.field.FIELD_DICT_DISABLE;
            disableArr = Array.isArray(disable) ? disable : isString(disable) ? disable.split(",") : [];
          } catch (exception) {
            disableArr = [];
          }
        }

        _.map(this.field.FIELD_DICT_NAME, (item) => {
          // 判断机构ORG_CODE TODO 不可编辑的要disable
          if (disableArr && disableArr.length > 0) {
            if (!_.isEmpty(_.find(disableArr, i => {
              return i == item.DICT_ITEM;
            }))) {
              item.IS_DISABLE = true;
            } else {
              item.IS_DISABLE = false;
            }
          } else if (this.field.FIELD_DICT_DISABLE && this.field.FIELD_DICT_DISABLE.length == 0) {
            item.IS_DISABLE = false;
          }
          this.optionsAll.push({
            "value": item.DICT_ITEM, "label": item.DICT_ITEM_NAME, 
            "isDisable": item.IS_DISABLE ? item.IS_DISABLE : false,
            "stockEnable": item.stockEnable ? item.stockEnable : false,
            "newAddDisable": item.newAddDisable,
            "SEL_TYPE": item.SEL_TYPE ? item.SEL_TYPE : "",
            "TRDACCT": item.TRDACCT ? item.TRDACCT : "",
            "TRDACCT_LIST": item.TRDACCT_LIST ? item.TRDACCT_LIST : [],
            "STKPBU": item.STKPBU || "",
            "stkpbuDisabled": item.stkpbuDisabled,
            "isDisableAddStock": item.isDisableAddStock ?item.isDisableAddStock : false,
          });
        });

        if (showArr.length == 0 || showArr.length == this.field.FIELD_DICT_NAME.length) {
          this.options = this.optionsAll;
        } else {
          // 如果当前值不在过滤后的字典内，将当前值清掉
          // 有可能是多选 DEFAULT_VALUE是多个带有,的值 进行优化修改
          let DEFAULT_VALUE = this.field.DEFAULT_VALUE ? this.field.DEFAULT_VALUE.split(",") : "";
          let NEW_DEFAULT_VALUE = [];
          _.each(DEFAULT_VALUE, item => {
            if (_.indexOf(showArr, item) > -1) {
              NEW_DEFAULT_VALUE.push(item);
            }
          });
          this.field.DEFAULT_VALUE = NEW_DEFAULT_VALUE.join(",");

          _.filter(this.field.FIELD_DICT_NAME, (item) => {
            // 判断机构ORG_CODE TODO 
            for (let j = 0; j < showArr.length; j++) {
              if (item.DICT_ITEM == showArr[j]) {
                this.options.push({
                  "value": item.DICT_ITEM, "label": item.DICT_ITEM_NAME, "isDisable": item.IS_DISABLE ? item.IS_DISABLE : false,
                  "stockEnable": item.stockEnable ? item.stockEnable : false,
                  "newAddDisable": item.newAddDisable,
                  "SEL_TYPE": item.SEL_TYPE ? item.SEL_TYPE : "",
                  "TRDACCT": item.TRDACCT ? item.TRDACCT : "",
                  "TRDACCT_LIST": item.TRDACCT_LIST ? item.TRDACCT_LIST : [],
                  "STKPBU": item.STKPBU || "",
                  "stkpbuDisabled": item.stkpbuDisabled
                });
              }
            }
          });
        }

        if (this.field.DEFAULT_VALUE && this.optionsAll.length == this.field.DEFAULT_VALUE.split(",").length) {
          this.chooseAll = true;
        }
      }
    },
    validatorField: function (rule, value, callback) {
      value = this.field.DEFAULT_VALUE;
      if (this.isBaseUI) { // 多选框选中和都不选中都广播值变更事件
        this.$emit("field-change", this.field);
      } else {
        this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
      }
    },
    //选择市场板块
    handleChecked (isChoose, item) {
      if (isChoose) {
        item.stockEnable = true;
        this.field["NEW_STOCK_INFO"] = item;
        this.updateClickEvent();
      } else {
        item.stockEnable = false;
        item.SEL_TYPE = "";
        item.TRDACCT = "";
        item.STKPBU = "";
        this.field["NEW_STOCK_INFO"] = item;
        this.updateClickEvent();
      }
    },
    //点击新开或加挂（选择已有证券账户）
    handleClick (e, item, val) {
      if (e.target.tagName === "INPUT" || !item.stockEnable || ( val=="1" && item.newAddDisable)) return;
      // consoleLog(e, item, val)
      if (item.SEL_TYPE == val) {
        item.SEL_TYPE = "";
        item.TRDACCT = "";
      } else {
        item.SEL_TYPE = val;
      }
      if (val == "1") {
        item.TRDACCT = "";
      }
      this.field["NEW_STOCK_INFO"] = item;
      this.updateClickEvent();
    },
    //选择已有证券账户
    handleSelect (item,flag) {
      //flag:主要用来区分是:1-输入交易单元触发的事件,0-输入证券账户时触发的事件
      item.stkpbuOrTrdacctFlag = flag;
      this.field["NEW_STOCK_INFO"] = item;
      this.updateClickEvent();
    },
    //触发字段点击事件
    updateClickEvent () {
      let data = {};
      data["FIELD_ID"] = this.field.FIELD_ID;
      data["GROUP_ID"] = this.groupId;
      data["MODULE_ID"] = this.field.MODULE_ID;
      data["index"] = "0";
      this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
    },
    handleCollapse () {
      this.collapseStu = !this.collapseStu;
    }
  },
  watch: {
    dictDisable () {
      this.initDict();
    },
    dictChange: {
      deep: true,
      handler: function (val) {
        this.initData();
        this.initDict();
      }
    },
    dataChange: function (val) {
      this.field.message = "";
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      this.initData();
    },
    dictFilterChange: function (val) {
      this.initDict();
    }
  }
};
</script>

<style lang="less">
@import "~@/styles/less/variable.less";
.open-biz-stock , .open-biz-stock .el-main .el-form-item {
    width: 100% !important;     
    // .el-form-item__content {
  // grid-gap: 10px; /* 可以根据需要调整元素之间的间隙 */
      
    //         // text-align: right;
    //   width: 100% !important;  
    //   .stock-list {
    //     // width: 80%;        
    //     .stock-item {
    //       width: 45% !important;
    //       // text-align: right !important;
    //       .stock-block{
    //         text-align: right !important;
    //         // display: inline-block !important; /* 使 span 元素能够设置宽度和对齐 */
    //         // text-align: left !important; /* 如果需要左对齐，可根据需要修改为 right 或 center */
    //       }
    //     }
    //   }    
    // }
    
}

       
.open-biz-stock {
   .el-form-item__label{
    display: none !important;//此组件隐藏前面的label
  }
  // min-height: 250px;//添加最低高度

  .el-form-item__content {
    width: 100% !important;  
    .stock-list {
      // width: 50%;
      display: flex;
      flex-wrap: wrap !important;
      .stock-item {
        width: 700px;//每个组件item宽度
        display: flex;
        align-items: center;
        // height: 100px;
        // height: 66px;
        height: 40px !important;
        // width: 100%;
        // margin-top: -2px;
        // border: 2px solid #ced2e1;
        margin-bottom: 16px;
       // margin-left: 5%;
        // border: 1px solid rgb(220, 223, 230);
        // box-sizing: border-box;
        // border-radius: 5px;
        .el-radio__label,
        .el-checkbox__label {
          // font-size: 24px;
          // padding: 0px;
          font-size: 14px;
        }
        &.stock-item-disable {
          position: relative;
          &::before{
              display: block;
              content: "";
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              z-index: 2;
              background-color:rgba(255, 255, 255, 0.35);
              background-image: none;
          }
          .module-item-input-disabled();
        }
        &.allow-input-stkpbu {
          .stock-select {
            // padding-left: 60px;
            width: 100px;
            .stock-select-inner {
              .el-input.stock-input-stkpbu {
                width: 160px;
                input {
                  display: inline-block
                }
                .el-input__inner {
                  padding: 0 5px;
                  text-align: center;
                }
              }
              .el-input.stock-input-tracct{
                 width: 171px;
              }
            }
          }
        }
      
        .stock-block {
          flex: 0 0 80px;
          display: inline-flex;
          align-items: center;
          // justify-content: flex-start;
          // justify-content: space-between; 
          // text-align: right;
          height: 100%;    
          // padding-right: 50px;
          // padding-left: 100px;
          // padding-left: 14px;
          // border-right: 1px solid #dee1e8;
          // box-sizing: border-box;
          // border: 5px solid #dee1e8;
          border: none;
          text-align: right;
          .stock-label{
            display: inline-block;
            text-align: center;
          }
          .el-checkbox {
            display: none;
            // width: 100px;
            text-align: right;
            padding-right: 8px;
            // display: flex;
            // align-items: center;
            .el-checkbox__input.is-checked+.el-checkbox__label{
              // font-size: 30px;
              color: #343434;
              // padding-right: 10px;
            }
            .el-checkbox__inner {
              // flex-basis: calc(50% - 10px) !important; /* 50%宽度，并留有一些间隙 */
              // margin-right: 10px !important; /* 右边距，可以根据需要调整 */
              display: none;//不显示             
            }        
          }
   
        }
        .stock-select {
          // padding-left: 100px;
          // padding-left: 14px;         
          position: relative;          
          .stock-select-inner {
            display:inline-flex;//统一水平显示
                    // .el-input{
          .error-message {
            position: absolute;
            margin-left: 210px;
            color: red;
            margin-top: 42px;
          }     
        .el-radio-group {  
          display: flex;
          .el-radio {
            display: inline-flex;
            align-items: center;
            // margin-left: 20px;
            margin-left: 8px;
            text-align: center;
            // width: 285px;
            height: 40px;
            background: #fff;
            // border: 2px solid #a5a9b3;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            padding: 0 24px 0 24px;
            &.is-checked {
              border-color: #e5c48a;
              .el-radio__label {        
                color: #e5c48a;            
              }
            }
            .el-radio__input {
              display: none;
            }
            .el-radio__label {
              // font-size: 20px;原始vtm
              font-size: 14px;
              display: block;
              margin: 0 auto;
              padding-left: 0;
            }
          }  
         }          
          .el-input,
            .el-select {
              margin-left: 8px;
              // width: 300px;
              width: 245px;
              // width: 100%;
              display: inline-block;  
              .el-input__inner {
 
              }
            }
          }
          .select-err-msg {
            position: absolute;
            margin-left: 10px;
            margin-top: 2px;
            // margin-left: 110px;
            // font-size: 18px;
            
            font-size: 14px;
            // font-weight: 500;
            // color: #e82d2d;
            color: #e5c48a;// color: #e82d2d;
            .el-icon-warning {
              // margin-right: 7px;             
            }           
          }
       
        }
      }
    }
  }
}
.stock-select-popper.el-select-dropdown {
  .el-select-dropdown__wrap {
    overflow: hidden;
    .el-select-dropdown__list {
      li {
        color: #4a4e53;
        background: #fff;
        &:nth-child(even) {
          background: #fff;
          // opacity: 0.8;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/openBizStockItem.vue